export const profile = {
    name: "DORIANTELIVE",

    tagline:
        "STREAMER // BUILDER // COMEBACK IN PROGRESS",

    intro:
        "Welcome to Doriantelive's Playground. A year ago my 12-year business fell apart, and I found myself rebuilding life from the ground up. Technology became more than an interest — it became a lifeline, and the only way I could earn money and keep my dog.",

    video:
        "/assets/MacknEyeProPic.webm",
};